import { AxiosInstance } from '@service/axios-instance';
import { OperationConfig } from '@utils/operation-config-options';

export async function listOperationConfigs(): Promise<OperationConfig[]> {
  const res = await AxiosInstance.get('/admin/operations_config', {
    withCredentials: true,
  });
  return res.data;
}

export async function saveOperationConfig(operation: OperationConfig): Promise<OperationConfig> {
  const res = await AxiosInstance.put('/admin/operations_config', operation, {
    withCredentials: true,
  });
  return res.data;
}

export async function getCurrentOperationConfig(db: string): Promise<OperationConfig> {
  const res = await AxiosInstance.get(`/operations/current_config?db=${encodeURIComponent(db)}`, {
    withCredentials: true,
  });
  return res.data;
}

export async function saveCurrentOperationConfig(db: string, operation: Partial<OperationConfig>): Promise<OperationConfig> {
  const res = await AxiosInstance.put(`/operations/current_config?db=${encodeURIComponent(db)}`, operation, {
    withCredentials: true,
  });
  return res.data;
}
